module.exports = __webpack_public_path__ + "static/img/128.85790cf.png";